// extracted by mini-css-extract-plugin
export var rightFloatingImgWrapper = "index-module--rightFloatingImgWrapper--17BVz";
export var leftFloatingImgWrapper = "index-module--leftFloatingImgWrapper--7jjk1";
export var top = "index-module--top--2_dcf";
export var bottom = "index-module--bottom--1VNTk";